import { render, staticRenderFns } from "./PlaceOrder.vue?vue&type=template&id=932eb7ce&scoped=true"
import script from "./PlaceOrder.vue?vue&type=script&lang=ts"
export * from "./PlaceOrder.vue?vue&type=script&lang=ts"
import style0 from "./PlaceOrder.vue?vue&type=style&index=0&id=932eb7ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932eb7ce",
  null
  
)

export default component.exports